import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-legals',
    templateUrl: './legals.component.html',
    styleUrls: ['./legals.component.scss'],
})
export class LegalsComponent {
    constructor() {}
}
